import { render, staticRenderFns } from "./LocationPlugin.vue?vue&type=template&id=455adf8c&scoped=true"
import script from "./LocationPlugin.vue?vue&type=script&lang=ts"
export * from "./LocationPlugin.vue?vue&type=script&lang=ts"
import style0 from "./LocationPlugin.vue?vue&type=style&index=0&id=455adf8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455adf8c",
  null
  
)

export default component.exports